//NEW VERSION
import { all, takeEvery } from "redux-saga/effects";
import { unfoldSaga } from "../unfoldSaga";
import ActionType from "./action-type";
import baseApi from "./api";
interface ITakeAction {
  callbacks?: any;
  params: any;
  formData: any;
  type: string;
  id?: any;
  onUploadProgress: any;
}

function* fetchImage({ callbacks, params, type }: ITakeAction) {
  yield unfoldSaga({
    handler: async () => {
      const response = await baseApi.fetchImage(params);
      return response;
    },
    key: type,
    callbacks: callbacks,
  });
}

function* uploadImage({
  callbacks,
  formData,
  onUploadProgress,
  type,
}: ITakeAction) {
  yield unfoldSaga({
    handler: async () => {
      const response = await baseApi.uploadImage(formData, onUploadProgress);
      const imageID = response?.result?.id;
      const mimeType = response?.meta?.mimeType;
      return { response, imageID, mimeType };
    },
    key: type, // Once and for all.
    callbacks: callbacks,
  });
}

function* deleteImage({
  type,
  id,
  callbacks,
}: ITakeAction) {
  yield unfoldSaga({
    handler: async () => {
      const response = await baseApi.deleteImage(id);
      return response;
    },
    key: type, // Once and for all.
    callbacks: callbacks,
  });
}

function* saveImage({
  callbacks,
  formData,
  onUploadProgress,
  type,
}: ITakeAction) {
  yield unfoldSaga({
    handler: async () => {
      const response = await baseApi.saveImage(formData, onUploadProgress);
      // const imageID = response?.result?.id;
      // const mimeType = response?.meta?.mimeType;
      return { response};
    },
    key: type, // Once and for all.
    callbacks: callbacks,
  });
}

function* fetchBusinessImages({ businessId, params, callbacks, type }: any) {
  yield unfoldSaga({
    handler: async () => {
      const response = await baseApi.fetchBusinessImages(businessId, params);
      return { ...response, businessId, params };
    },
    key: type,
    callbacks: callbacks,
  });
}

function* uploadPublicImage({ formData, callbacks, onUploadProgress, businessId, type }: any) {
  yield unfoldSaga({
    handler: async () => {
      const response = await baseApi.uploadPublicImage(formData, onUploadProgress, businessId);
      return response;
    },
    key: type,
    callbacks: callbacks,
  });
}

function* deleteMultipleFiles({ imageIds, businessId, callbacks, type }: any) {
  yield unfoldSaga({
    handler: async () => {
      const response = await baseApi.deleteMultipleFiles(imageIds, businessId);
      return response;
    },
    key: type,
    callbacks: callbacks,
  });
}

export default function* toMediaSaga () {
  yield all([takeEvery(ActionType.UPLOAD_IMAGE, uploadImage)]);
  yield all([takeEvery(ActionType.FETCH_IMAGE, fetchImage)]);
  yield all([takeEvery(ActionType.SAVE_IMAGE, saveImage)]);
  yield all([takeEvery(ActionType.DELETE_IMAGE, deleteImage)]);
  yield all([takeEvery(ActionType.FETCH_BUSINESS_IMAGES, fetchBusinessImages)]);
  yield all([takeEvery(ActionType.UPLOAD_PUBLIC_IMAGE, uploadPublicImage)]);
  yield all([takeEvery(ActionType.DELETE_MULTIPLE_FILES, deleteMultipleFiles)]);
}
